import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import { FormGroup, FormControl } from 'react-bootstrap';
import classNames from 'classnames';
import MaskedInput from 'react-text-mask';

const FormField = ({
	title,
	subTitle,
	value,
	addOn,
	hasSeperator,
	isEdit,
	onChange,
	placeholder,
	isError,
	type,
	inputMask,
	name,
	disabled,
}) => (
	<Fragment>
		<div className="flex position-relative">
			<p className="flex-1 margin-bottom-5 margin-top-5">
				<strong className="display-block">{ title }</strong>
				<If condition={subTitle}>
					<small>{ subTitle }</small>
				</If>
			</p>
			<Choose>
				<When condition={!isUndefined(inputMask) && !isUndefined(value) && isEdit}>
					<div className="flex-3 margin-bottom-0">
						<MaskedInput
							className={classNames('form-control settings-form-field', { 'input-error' : isError })}
							type={type || 'text'}
							guide={false}
							value={value}
							onChange={onChange}
							mask={inputMask}
							placeholder={placeholder}
							disabled={disabled}
						/>
					</div>
				</When>
				<When condition={!isUndefined(value) && isEdit}>
					<FormGroup
						className="flex-3 margin-bottom-0"
						validationState={isError ? 'error' : null}
					>
						<FormControl
							className="settings-form-field"
							name={name}
							type={type || 'text'}
							value={value}
							onChange={onChange}
							placeholder={placeholder}
							disabled={disabled}
						/>
					</FormGroup>
				</When>
				<When condition={value && !isEdit}>
					<p className="flex-3 margin-bottom-5 margin-top-5">{ value }</p>
				</When>
			</Choose>
			<If condition={!!addOn}>
				{ addOn }
			</If>
		</div>
		<If condition={hasSeperator}>
			<div className="separator" />
		</If>
	</Fragment>
);

FormField.propTypes = {
	addOn        : PropTypes.any,
	disabled     : PropTypes.bool,
	hasSeperator : PropTypes.bool,
	inputMask    : PropTypes.array,
	isEdit       : PropTypes.bool,
	isError      : PropTypes.bool,
	name         : PropTypes.string,
	onChange     : PropTypes.func,
	placeholder  : PropTypes.string,
	subTitle     : PropTypes.string,
	title        : PropTypes.string,
	type         : PropTypes.string,
	value        : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
};

FormField.defaultProps = {
	addOn        : undefined,
	disabled     : false,
	hasSeperator : false,
	inputMask    : undefined,
	isEdit       : false,
	isError      : false,
	name         : '',
	onChange     : () => undefined,
	placeholder  : '',
	subTitle     : '',
	title        : '',
	type         : '',
	value        : undefined,
};

export default FormField;
